import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Routes } from "react-router-dom";
export function RoutesWrapper({ children }) {
	const dispatch = useDispatch();

	const navigate = useNavigate();

	return (
		<>
			<Routes>{children}</Routes>
		</>
	);
}
